export const INSTITUTION_CHANGE_REASON_OTHER_MAX_LENGTH = 1000;
